import { __extends } from "tslib";
import { StopDeliveryStreamEncryptionInput, StopDeliveryStreamEncryptionOutput } from "../models/models_0";
import { deserializeAws_json1_1StopDeliveryStreamEncryptionCommand, serializeAws_json1_1StopDeliveryStreamEncryptionCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var StopDeliveryStreamEncryptionCommand = /** @class */ (function (_super) {
    __extends(StopDeliveryStreamEncryptionCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function StopDeliveryStreamEncryptionCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    StopDeliveryStreamEncryptionCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "FirehoseClient";
        var commandName = "StopDeliveryStreamEncryptionCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: StopDeliveryStreamEncryptionInput.filterSensitiveLog,
            outputFilterSensitiveLog: StopDeliveryStreamEncryptionOutput.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    StopDeliveryStreamEncryptionCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1StopDeliveryStreamEncryptionCommand(input, context);
    };
    StopDeliveryStreamEncryptionCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1StopDeliveryStreamEncryptionCommand(output, context);
    };
    return StopDeliveryStreamEncryptionCommand;
}($Command));
export { StopDeliveryStreamEncryptionCommand };
//# sourceMappingURL=StopDeliveryStreamEncryptionCommand.js.map